/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
const translations = {
  generalCategory: {
    death: "Todesfall",
    inheritance: "Erbe",
    both: "Todesfall und Erbe",
  },
  deathCategory: {
    current: "Ja",
    preparation: "Nein",
  },
  inheritanceCategory: {
    heir: "Erbe",
    bequeather: "Vererben",
  },
};

export default translations;
